import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { InstanceService } from 'src/app/service/instance.service';
import { CurrencyService } from 'src/app/service/currency.service';
import { CreateInstanceModel } from 'src/app/model/create-instance.model';
import swal from "sweetalert2";

@Component({
  selector: 'app-baixa',
  templateUrl: './baixa.component.html',
  styleUrls: ['./baixa.component.scss']
})
export class BaixaComponent {
  @Input() attributes: AttributeModel[]; // Recebe os atributos do modal
  @Output() close = new EventEmitter<void>(); // Emite evento para fechar o modal

  documento: string;
  valor: number;
  dataVencimento: string;
  venda: string;
  compradorId: string;
  vendedorId: string;
  chaveDanfe: string;
  identificador: string;
  selectedItem: AttributeModel;

  constructor(
    private instanceService: InstanceService,
    private currencyService: CurrencyService
  ) {}

  ngOnInit(): void {
    if (this.attributes) {
      const documentAttr = this.attributes.find(
        (attr) => attr.key.toLowerCase() == "número"
      );
      const valueAttr = this.attributes.find(
        (attr) => attr.key.toLowerCase() == "valor"
      );
      const dueDateAttr = this.attributes.find(
        (attr) => attr.key.toLowerCase() == "venc"
      );
      this.documento = documentAttr ? documentAttr.value : null;
      this.valor = valueAttr ? parseFloat(valueAttr.value.replace(/\./g, '').replace(',', '.')) : null; 
      const [day, month, year] = dueDateAttr?.value?.split("/") || [];
      this.dataVencimento = dueDateAttr ? `${year}-${month}-${day}` : null;
      this.selectedItem = { key: '', type: '', value: '', attributes: this.attributes };
    } else {
      console.error('Attributes are null or undefined.');
    }
  }

  closeModal(): void {
    this.close.emit(); // Emite o evento para fechar o modal
  }

  onBaixarBoleto($motivo: string, $item: AttributeModel) {
    const vendaAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "venda"
    );
    this.venda = vendaAttr ? vendaAttr.value : null;

    const compradorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "comprador id"
    );
    this.compradorId = compradorIdAttr ? compradorIdAttr.value : null;

    const vendedorIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "vendedor id"
    );
    this.vendedorId = vendedorIdAttr ? vendedorIdAttr.value : null;

    const chaveDanfeAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "chave danfe"
    );
    this.chaveDanfe = chaveDanfeAttr ? chaveDanfeAttr.value : null;

    const identificadorAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "identificador externo"
    );

    const policyIdAttr = $item.attributes.find(
      (attr) => attr.key.toLowerCase() == "policy id baixa"
    );

    this.identificador = identificadorAttr ? identificadorAttr.value : null;
    let instancia = new CreateInstanceModel();
    instancia.policyId = policyIdAttr?.value;
    instancia.attributes = [
      {
        key: "Identificador Externo",
        value: this.identificador,
        type: "Text",
      },
      {
        key: "Venda",
        value: this.venda,
        type: "Text",
      },
      {
        key: "Comprador",
        value: this.compradorId,
        type: "Text",
      },
      {
        key: "Vendedor",
        value: this.vendedorId,
        type: "Text",
      },
      {
        key: "Chave Danfe",
        value: this.chaveDanfe,
        type: "Text",
      },
      {
        key: "Documento",
        value: this.documento,
        type: "Text",
      },
      {
        key: "Vencimento",
        value: this.dataVencimento,
        type: "Date",
      },
      {
        key: "Valor do boleto",
        value: this.currencyService.getCurrencyStringAsNumberNormalized(this.valor.toString()),
        type: "Text",
      },
      {
        key: "Motivo",
        value: $motivo,
        type: "Text",
      },
    ];

    try {
      this.instanceService.save(instancia).subscribe();
      swal.fire({
        title: "Successo",
        text: "Solicitação de baixa enviada com sucesso.",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao enviar solicitação de baixa.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    this.closeModal();
  }
}
